import { PayloadAction } from 'typesafe-actions';
import { CardDetailsState, CardDetailsContextActionTypes } from './types';

const CardDetailsReducer = (
  state: CardDetailsState,
  action: PayloadAction<CardDetailsContextActionTypes, any>,
): CardDetailsState => {
  switch (action.type) {
    case CardDetailsContextActionTypes.SetSelectedCardTransaction:
      return {
        ...state,
        selectedCardTransaction: action.payload,
      };

    case CardDetailsContextActionTypes.SetSelectedCard:
      return {
        ...state,
        selectedCard: action.payload,
      };

    case CardDetailsContextActionTypes.SetSelectedPaymentCardIdentifications:
      return {
        ...state,
        selectedPaymentCardIdentifications: action.payload,
      };

    case CardDetailsContextActionTypes.SetSelectedCardAction:
      return {
        ...state,
        selectedCardAction: action.payload,
      };

    case CardDetailsContextActionTypes.SetCardTransactionsFilters:
      return {
        ...state,
        cardTransactionsFilters: action.payload,
      };

    default:
      return state;
  }
};

export { CardDetailsReducer };
